import React from "react";

const RateRange = ({
  min = 1,
  max = 5,
  name,
  minLabel = "Poor",
  maxLabel = "Excellent",
  children,
}) => {
  let options = [];
  for (let i = min; i <= max; i++) {
    options.push(<option value={i} label={i} key={i} />);
  }
  return (
    <label className="text-sm my-2 block">
      <datalist id={`${name}-list`} style={{ writingMode: "vertical-lr" }}>
        {options}
      </datalist>
      {children}
      <div className="flex gap-2">
        <span>{minLabel}</span>
        <input
          type="range"
          name={name}
          min={min}
          max={max}
          required={true}
          list={`${name}-list`}
        />
        <span>{maxLabel}</span>
      </div>
    </label>
  );
};

export default RateRange;
